/**
 * Leaflet, plus the global the cluster plugin needs.
 *
 * leaflet.markercluster ships a UMD bundle that never requires Leaflet — under
 * webpack it takes the CommonJS branch and then reaches for a global `L` that
 * would not otherwise exist. Assigning it here (rather than in maps.js) is what
 * makes the ordering reliable: ES imports are hoisted, so `window.L = L` written
 * beside an `import 'leaflet.markercluster'` would run *after* the plugin had
 * already executed and failed. Importing this module first guarantees the global
 * is in place before the plugin body runs.
 */
import L from 'leaflet';

window.L = L;

export default L;
